module.exports = __webpack_public_path__ + "static/media/slide-4.6a1578db.jpg";